module.exports = __webpack_public_path__ + "static/media/magneto.dfa97d36.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/magneto.jpeg
// module id = 287
// module chunks = 0